import React, { useState } from "react";
import { usePostBookingReviewRequestMutation } from "../../../rtk-query/slices/bookings/booking-slice";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Spinner } from "react-bootstrap";
import RequestSubmittedModal from "../modals/RequestSubmittedModal";

const BDActions = () => {
  const { id } = useParams();
  const [postBookingReviewRequest, { isLoading }] =
    usePostBookingReviewRequestMutation();

  const [isShowRSModal, setIsShowRSModal] = useState(false);

  const handleButtonSubmit = async () => {
    try {
      const response = await postBookingReviewRequest(id);
      if (response?.data) {
        setIsShowRSModal(true);
      }
      if (response?.error) {
        const errors = response?.error?.data?.errors;
        if (response?.error?.status === 401) {
          localStorage.removeItem("DODLoginToken");
          toast.error(response?.error?.data?.message);
        } else {
          toast.error(response?.error?.data?.message);
        }
      }
    } catch (error) {
      toast.error(error?.data?.message);
    }
  };
  return (
    <div className="bd-p-actions col-lg-5 mt-lg-0 mt-3 d-flex justify-content-end">
      <button
        className="submit-btn"
        disabled={isLoading}
        onClick={() => handleButtonSubmit()}
      >
        Request a review {isLoading && <Spinner size="sm" className="ms-2" />}
      </button>
      <RequestSubmittedModal
        show={isShowRSModal}
        handleClose={() => setIsShowRSModal(false)}
      />
    </div>
  );
};

export default BDActions;
